import { cn } from '@spiaggeit/spit-ui'
import { ComponentPropsWithoutRef } from 'react'

import styles from './DangerousHtml.module.css'

interface DangerousHtmlProps extends ComponentPropsWithoutRef<'div'> {
  className?: string
  html: string
}

export const DangerousHtml = (props: DangerousHtmlProps) => {
  const { html, className, ...rest } = props

  return (
    <div
      className={cn(styles['dangerous-html'], className)}
      dangerouslySetInnerHTML={{ __html: props.html.replace(/\n/g, '<br />') }}
      {...rest}
    />
  )
}
